export function Logo({ className = "" }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {/* The FitBuddy mark: a chunky calorie-bank gauge — fat teal arc, sun
          coin hub, and the payout spark where the balance jumps up. */}
      <svg
        viewBox="0 0 64 64"
        className="h-10 w-10 shrink-0"
        aria-hidden
        focusable="false"
      >
        <path
          d="M 44.5 49.09 A 21 21 0 1 1 44.5 16.91"
          fill="none"
          stroke="#0F2240"
          strokeWidth="13"
          strokeLinecap="round"
        />
        <path
          d="M 44.5 49.09 A 21 21 0 1 1 20.5 14.81"
          fill="none"
          stroke="#0D9488"
          strokeWidth="8"
          strokeLinecap="round"
        />
        <path
          d="M 20.5 14.81 A 21 21 0 0 1 44.5 16.91"
          fill="none"
          stroke="#14B8A6"
          strokeWidth="8"
          strokeLinecap="round"
        />
        <circle cx="31" cy="33" r="9.5" fill="#FFC93C" stroke="#0F2240" strokeWidth="4" />
        <path
          d="M 31 33 L 40.2 23.8"
          fill="none"
          stroke="#0F2240"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <circle cx="27.6" cy="29.6" r="1.9" fill="#FFFFFF" />
        <path
          d="M 52.5 2.5 L 55 8.5 L 61 11 L 55 13.5 L 52.5 19.5 L 50 13.5 L 44 11 L 50 8.5 Z"
          fill="#FFC93C"
          stroke="#0F2240"
          strokeWidth="2.75"
          strokeLinejoin="round"
        />
      </svg>
      <span className="font-display text-xl font-extrabold tracking-tight text-navy">
        Fit<span className="text-teal">Buddy</span>
      </span>
    </span>
  );
}
